import { UiNode, UiText } from "@ory/kratos-client";
import set from "lodash.set";
import { DefaultValues } from "react-hook-form";

import { isUiNodeInputAttributes } from "./ui";

export interface InitialFormState<T> {
  initialValues: DefaultValues<T>;
  initialErrors: Partial<Record<keyof T, string>>;
  initialTouched: Partial<Record<keyof T, boolean>>;
}

export function getInitialFormState<T>(nodes: UiNode[]): InitialFormState<T> {
  const state: InitialFormState<T> = {
    initialValues: {} as DefaultValues<T>,
    initialErrors: {},
    initialTouched: {},
  };
  nodes.forEach(({ messages, attributes }) => {
    if (isUiNodeInputAttributes(attributes) && attributes.type !== "submit") {
      // Set initial value
      state.initialValues = set(
        state.initialValues,
        attributes.name,
        attributes.value ?? ""
      );

      // If there are error messages, initialize the error and mark field as touched.
      const errorMessages = getErrorMessages(messages);
      if (errorMessages.length > 0) {
        state.initialErrors = set(
          state.initialErrors,
          attributes.name,
          errorMessages.map((message) => message.text).join("\n")
        );
        state.initialTouched = set(state.initialTouched, attributes.name, true);
      }
    }
  });
  return state;
}

function getErrorMessages(messages: UiText[]): UiText[] {
  return messages.filter((message) => message.type === "error");
}
